import VueInitProps from './vue-init-props'

export default VueInitProps
